import { WorkflowVisualizationContextMenuActionButton } from "@containers/common/workflow-visualization-container/workflow-visualization-policy-configs-container/workflow-visualization-context-menu/workflow-visualization-context-menu-action-button/workflow-visualization-context-menu-action-button";
import styles from "./workflow-visualization-context-menu.less";

type WorkflowVisualizationContextMenuProps = {
    id: string;
    top: number;
    left: number;
    right: number;
    bottom: number;
    onClick: () => void;
    menuRef: React.MutableRefObject<any>;
    actions: Array<{
        label: string;
        action: (id: string) => void;
        disabled?: boolean;
        tooltip?: string;
        actionId: string;
    }>;
};

export const WorkflowVisualizationContextMenu = (props: WorkflowVisualizationContextMenuProps) => {
    const {
        id,
        top,
        left,
        right,
        bottom,
        onClick,
        menuRef,
        actions
    } = props;
    const idPrefix = 'workflow-visualization-context-menu';

    return (
        <div
            style={{ top, left, right, bottom }}
            ref={menuRef}
            className={styles.contextMenu}
            onClick={onClick}
        >
            {actions.map(action => (
                <WorkflowVisualizationContextMenuActionButton
                    key={`action-${action.actionId}`}
                    {...action}
                    idPrefix={idPrefix}
                    targetId={id}
                />
            ))}
        </div>
    );
}